import { Link, Outlet } from 'react-router';
import { useAuth } from './AuthContext';

/**
 * Route guard for the admin CMS. By the time this renders the AuthGate has
 * already ensured a signed-in user and resolved admin status, so a non-admin
 * gets a clear "not authorized" message rather than a redirect loop.
 */
export function RequireAdmin() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <div className='tw:flex tw:min-h-screen tw:flex-col tw:items-center tw:justify-center tw:bg-ed-cream tw:px-6 tw:text-center'>
        <h1 className='tw:font-serif tw:text-3xl tw:text-ed-black'>Not authorized</h1>
        <p className='tw:mt-3 tw:max-w-md tw:text-ed-charcoal/70'>
          You're signed in, but this area is limited to Eighty Days administrators.
        </p>
        <Link
          to='/'
          className='tw:mt-8 tw:bg-ed-gold tw:px-6 tw:py-3 tw:text-sm tw:tracking-widest tw:uppercase tw:text-ed-black tw:transition-colors tw:hover:bg-ed-black tw:hover:text-ed-cream'
        >
          Back to experiences
        </Link>
      </div>
    );
  }

  return <Outlet />;
}
